import { FieldValues, Path, Validate } from "react-hook-form";
import { TheoryLectureAbbreviation, TheoryLectureCategory } from "../model/TheoryLecture";
import { SelectInput } from "./SelectInput";
import { useCurrentDrivingSchool } from "../hooks/useCurrentDrivingSchool";

export function TheoryLectureInput(props: {
  label: "Lektion";
  source: Path<FieldValues>;
  category?: TheoryLectureCategory;
  validate?: Validate<TheoryLectureAbbreviation, FieldValues>;
  size: "small";
}) {
  const { label, source, category, validate, size } = props;
  const drivingSchool = useCurrentDrivingSchool();
  const optionsWithGroup = drivingSchool.customizations.includes("tractors")
    ? [...standardTheoryLectureOptionsWithGroup, ...theoryLectureOptionsWithGroupForTractors]
    : standardTheoryLectureOptionsWithGroup;
  const groups = category ? [_groupByCategory[category]!] : [...new Set(optionsWithGroup.map(([, , group]) => group))];
  return (
    <SelectInput
      source={source}
      label={label}
      optionsWithGroups={optionsWithGroup}
      groups={groups}
      validate={validate}
      size={size}
    />
  );
}

const _groupByCategory: Partial<Record<TheoryLectureCategory, string>> = {
  Grundstoff: "Grundstoff",
  Zusatzstoff_A: "Zusatzstoff Klasse A",
  Zusatzstoff_B: "Zusatzstoff Klasse B",
  B96: "Klasse B96",
  Zusatzstoff_L: "Zusatzstoff Klasse L",
  Zusatzstoff_T: "Zusatzstoff Klasse T",
};

const standardTheoryLectureOptionsWithGroup: Array<[TheoryLectureAbbreviation, string, string]> = [
  ["G1", "Lektion 1: Was brauchst Du?", "Grundstoff"],
  ["G2", "Lektion 2: Persönliches zuerst!", "Grundstoff"],
  ["G3", "Lektion 3: Der Mensch!", "Grundstoff"],
  ["G4", "Lektion 4: Die Straße!", "Grundstoff"],
  ["G5", "Lektion 5: Du oder ich?", "Grundstoff"],
  ["G6", "Lektion 6: Hilfe durch den Schilderwald.", "Grundstoff"],
  ["G7", "Lektion 7: Alle Anderen!", "Grundstoff"],
  ["G8", "Lektion 8: Hier wirds schnell!", "Grundstoff"],
  ["G9", "Lektion 9: Fahren!", "Grundstoff"],
  ["G10", "Lektion 10: Alles steht still.", "Grundstoff"],
  ["G11", "Lektion 11: Bei Nacht und weitere Leuchten", "Grundstoff"],
  ["G12", "Lektion 12: Kommunikation und Lernen", "Grundstoff"],
  ["A1", "Lektion A1: Du und dein Motorrad", "Zusatzstoff Klasse A"],
  ["A2", "Lektion A2: Aufpassen! (Teil 1)", "Zusatzstoff Klasse A"],
  ["A3", "Lektion A3: Aufpassen! (Teil 2)", "Zusatzstoff Klasse A"],
  ["A4", "Lektion A4: Wie geht dein Motorrad?", "Zusatzstoff Klasse A"],
  ["B1", "Lektion B1: Das Auto", "Zusatzstoff Klasse B"],
  ["B2", "Lektion B2: Anhänger mit B", "Zusatzstoff Klasse B"],
  ["B96", "Theorie Klasse B96", "Klasse B96"],
];

const theoryLectureOptionsWithGroupForTractors: Array<[TheoryLectureAbbreviation, string, string]> = [
  ["L1", "Lektion L1: Verkehrsbeobachtung und Zusammenstellen von Zügen", "Zusatzstoff Klasse L"],
  ["L2", "Lektion L2: Fahrzeugtechnik und Sicherungseinrichtungen", "Zusatzstoff Klasse L"],
  ["T1", "Lektion T1: Verkehrsbeobachtung und Zusammenstellen von Zügen", "Zusatzstoff Klasse T"],
  ["T2", "Lektion T2: Fahrzeugtechnik und Sicherungseinrichtungen", "Zusatzstoff Klasse T"],
  ["T3", "Lektion T3: Fahrbetrieb mit Zügen und Ladungssicherung", "Zusatzstoff Klasse T"],
  ["T4", "Lektion T4: Physikalische Grundlagen und Fahrstabilität", "Zusatzstoff Klasse T"],
  ["T5", "Lektion T5: Druckluft- und kombinierte Bremsanlagen", "Zusatzstoff Klasse T"],
  ["T6", "Lektion T6: Bremsanlagen und Beleuchtung des Anhängers", "Zusatzstoff Klasse T"],
];
